<template>
  <div id="datafilling">
    <!-- 手机端 -->
    <div class="phone" v-if="flag == 2">
      <my_dialog
        v-if="dialogData.flag"
        :myDialogData="dialogData"
        @handleClick="handleClick"
      >
      </my_dialog>
    </div>

    <!-- PC端 -->
    <div class="pc" v-if="flag == 1">
      <my_dialogPc
        v-if="dialogData.flag"
        :myDialogData="dialogData"
        @handleClick="handleClick"
      >
      </my_dialogPc>
    </div>
  </div>
</template>

<script>
import * as datafillingData from "./datafilling.js";
export default {
  data() {
    return {
      flag: 0, //手机端和pc端切换
      dialogData: {
        flag: true,
        title: "资料申请填写",
        data: datafillingData.getdatafillingDialogData(),
        btns: [
          {
            active: "submit",
            btnName: "提交申请",
          },
        ],
        goBack: {
          active: "goBack",
          btnName: "返回",
        },
        statusCheckFile: [], //学籍资料审核表
        statusCheckFileName: "", //学籍资料审核表
        stuStatusFile: [], //所在学校学籍卡
        stuStatusFileName: "", //所在学校学籍卡
        idCardFile: [], //身份证正反面
        withoutTestFile: [], //免试(材料)
        withoutTestFileName: "", //免试(材料)
        otherScoreFile: [], //加分(材料)
        otherScoreFileName: "", //加分(材料)
      },
      tJInfo: {},
    };
  },
  methods: {
    start() {
      if (window.screen.width / window.screen.height > 1) {
        this.flag = 1;
        this.judgment();
      } else {
        // this.flag = 2;
        // this.judgment();
        this.$message({
          type: "warning",
          message: "请用电脑端查看!",
        });
        return;
      }
    },
    //进入页面根据资料id判断是(提交)还是(重提)
    judgment() {
      console.log("提交材料", sessionStorage.getItem("enrollId"));
      //资料id为空时是刚注册信息,带入注册时填写的信息
      if (
        sessionStorage.getItem("enrollId") == "" ||
        sessionStorage.getItem("enrollId") == null
      ) {
        for (let index = 0; index < this.dialogData.data.length; index++) {
          const element = this.dialogData.data[index];
          if (element.key == "idCard") {
            element.value = sessionStorage.getItem("registrationidCard");
          }
          if (element.key == "phone") {
            element.value = sessionStorage.getItem("registrationphone");
          }
          if (element.key == "profession") {
            element.value = sessionStorage.getItem("registrationprofession");
          }
          if (element.key == "school") {
            element.value = sessionStorage.getItem("registrationschool");
          }
        }
        // let requestData = {
        //   enrollId: sessionStorage.getItem("enrollId"),
        //   flag: "1",
        // };
        // this.$request("post", "/enrollInfo/getEnroll", requestData, (data) => {
        //   this.dialogData.data.forEach((element) => {
        //     element.value = data[element.key];
        //   });
        // });
      } else {
        //重提
        let requestData = {
          flag: "1",
          studentId: sessionStorage.getItem("ID"),
        };
        this.$request("post", "/enrollInfo/getEnroll", requestData, (data) => {
          console.log("重新提交", data);
          this.tJInfo = data;

          // this.dialogData.data = data;
          for (let index = 0; index < this.dialogData.data.length; index++) {
            const element = this.dialogData.data[index];
            if (element.key == "name") {
              element.value = data.name;
            }
            if (element.key == "sex") {
              element.value = data.sex;
            }
            if (element.key == "nation") {
              element.value = data.nation;
            }
            //身份证号有值了
            if (element.key == "idCard") {
              element.value = data.idCard;
            }
            if (element.key == "political") {
              element.value = data.political;
            }
            if (element.key == "stuNum") {
              element.value = data.stuNum;
            }
            //手机号有值了
            if (element.key == "phone") {
              element.value = data.phone;
            }
            if (element.key == "stuStatusNum") {
              element.value = data.stuStatusNum;
            }
            if (element.key == "edSystem") {
              element.value = data.edSystem;
            }
            //学校已经有值了
            if (element.key == "school") {
              element.value = data.school;
            }
            //专业也已经有值了
            if (element.key == "profession") {
              element.value = data.profession;
            }
            if (element.key == "schoolAddress") {
              element.value = data.schoolAddress;
            }
            if (element.key == "readyProfession") {
              element.value = data.readyProfession;
            }
            if (element.key == "statusCheckFile") {
              element.fileList = data.statusCheckFile;
            }
            if (element.key == "stuStatusFile") {
              element.fileList = data.stuStatusFile;
            }
            if (element.key == "idCardFile") {
              element.idcardImgLIst = data.idCardFile;
            }
            if (element.key == "withoutTestFile") {
              element.fileList = data.withoutTestFile;
            }
            if (element.key == "otherScoreFile") {
              element.fileList = data.otherScoreFile;
            }
          }
        });
      }
    },
    handleClick(active) {
      switch (active) {
        case "submit":
          let requestData = {};
          //提交前先判断资料id是否为空
          for (let index = 0; index < this.dialogData.data.length; index++) {
            const element = this.dialogData.data[index];
            /* 非空判断 */

            if (!element.isNull && element.value == "") {
              this.$message.error(element.name + "不可为空!");
              return;
            }
            if (!element.isNull && element.fileList == 0) {
              this.$message.error(element.name + "不可为空!");
              return;
            }
            if (
              !element.isNull &&
              element.key == "idCardFile" &&
              element.idCardflag == "0"
            ) {
              this.$message.error(element.name + "不可为空!");
              return;
            }

            //注册信息的时候,已经填写过注册信息了
            /* 手机号正确性合法性判断 */
            if (
              element.key == "phone" &&
              !this.$mobilePhoneNumberCheck.mobilePhoneNumberCheck(
                element.value
              )
            ) {
              this.$message.error("请填写正确格式的手机号!");
              return;
            }
            /* 身份证号正确性合法性判断 */
            if (
              element.key == "idCard" &&
              !this.$idCardValidity.idCardValidity(element.value)
            ) {
              this.$message.error("请填写正确格式的身份证号!");
              return;
            }

            if (element.key == "name") {
              requestData.name = element.value;
            }
            if (element.key == "sex") {
              requestData.sex = element.value;
            }
            if (element.key == "nation") {
              requestData.nation = element.value;
            }
            //身份证号有值了
            if (element.key == "idCard") {
              requestData.idCard = element.value;
            }
            if (element.key == "political") {
              requestData.political = element.value;
            }
            if (element.key == "stuNum") {
              requestData.stuNum = element.value;
            }
            //手机号有值了
            if (element.key == "phone") {
              requestData.phone = element.value;
            }
            if (element.key == "stuStatusNum") {
              requestData.stuStatusNum = element.value;
            }
            if (element.key == "edSystem") {
              requestData.edSystem = element.value;
            }
            //学校已经有值了
            if (element.key == "school") {
              requestData.school = element.value;
            }
            //专业也已经有值了
            if (element.key == "profession") {
              requestData.profession = element.value;
            }
            if (element.key == "schoolAddress") {
              requestData.schoolAddress = element.value;
            }
            if (element.key == "readyProfession") {
              requestData.readyProfession = element.value;
            }
            if (element.key == "statusCheckFile") {
              requestData.statusCheckFile = element.fileList;
            }
            if (element.key == "stuStatusFile") {
              requestData.stuStatusFile = element.fileList;
            }
            if (element.key == "idCardFile") {
              requestData.idCardFile = element.idcardImgLIst;
            }
            if (element.key == "withoutTestFile") {
              requestData.withoutTestFile = element.fileList;
            }
            if (element.key == "otherScoreFile") {
              requestData.otherScoreFile = element.fileList;
            }
            if (sessionStorage.getItem("enrollId") == "") {
              requestData.id = sessionStorage.getItem("enrollId");
              requestData.studentId = sessionStorage.getItem("ID");
            } else {
              requestData.id = sessionStorage.getItem("enrollId");
              requestData.studentId = sessionStorage.getItem("ID");
            }
          }
          this.$confirm("材料一旦提交,不可更改,请仔细核对后提交", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$request(
                "post",
                "/enrollInfo/subEnrollInfo",
                requestData,
                (data) => {
                  this.$router.push("/dataRequest");
                  sessionStorage.setItem("enrollId", data.id);
                  sessionStorage.setItem("name", data.name);
                  this.$message({
                    type: "success",
                    message: "提交成功!",
                  });
                }
              );
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消提交",
              });
            });

          break;
        case "goBack":
          this.$confirm("返回后,填写的资料将不会被保存", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$router.push("/dataRequest");
              this.$message({
                type: "success",
                message: "返回成功!",
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消返回",
              });
            });

          break;

        default:
          break;
      }
    },
  },
  mounted() {
    this.start();
  },
};
</script>

<style lang="less" scoped>
#datafilling {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .phone {
    width: 100%;
    height: 100%;
  }
  .pc {
    width: 100%;
    height: 100%;
    background: rgba(245, 245, 245, 1);
  }
}
</style>
